<template>
  <div class="trainer-session-counter sesscount csst">
    <i class="mdi mdi-cards-playing-spade sesscount_icon"></i>
    <div
      class="sesscount_value text-nowrap"
      :class="{ sesscount_value_visible: allVisible }"
    >
      {{ sessionHand || 0 }}
      <span v-if="sessionMaxHands !== Infinity">&nbsp;/ {{ sessionMaxHands }} </span>
      <!-- <span v-if="sessionMaxHands !== Infinity">/{{ sessionMaxHands }} </span> -->
    </div>
    <div
      class="csst_content clr-white text-nowrap"
      style="position: fixed; margin-top: -3.5em"
    >
      {{ $t('tooltips.trainer_session_counter') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerSessionCounter',
  props: {
    sessionHand: [Number, String],
    sessionMaxHands: [Number, String],
  },
  data() {
    return {
      allVisible: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.allVisible = true
    }, 220)
  },
}
</script>
<style lang="scss" scoped>
.sesscount {
  border-radius: 8px;
  line-height: 1;
  flex: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--clr-grey-2);
  transition: 0.22s;
  &_icon {
    position: relative;
    font-size: 1.25rem;
    --anim-duration: 220ms;
    &_cont {
      position: relative;
      transition: transform var(--anim-duration);
      display: flex;
      &_roll {
        transform: scale(1.2);
      }
    }
  }
  &_value {
    font-weight: 500;
    font-size: 0.875rem;
    padding-left: 0.25rem;
    position: relative;
    display: flex;

    left: -2rem;
    opacity: 0;
    font-weight: 700;
    transition: 0.15s;
    &_visible {
      left: 0;
      opacity: 1;
    }
  }
  &_hands {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.15s;
  }
}
</style>
